<template>
  <th class="sortable" @click="handleSort">
    <slot></slot>
    <span class="sort-indicator" :class="{ active: isActive }">
      {{ sortIndicator }}
    </span>
  </th>
</template>

<script setup>
import { computed, ref, watch } from 'vue';

const props = defineProps({
  column: String,
  currentSort: String,
  defaultDirection: {
    type: String,
    default: 'desc'
  }
});

const emit = defineEmits(['sort']);

const direction = ref(props.defaultDirection);

const isActive = computed(() => props.column === props.currentSort);

const sortIndicator = computed(() => {
  if (isActive.value) {
    return direction.value === 'asc' ? '▲' : '▼';
  }
  return props.defaultDirection === 'asc' ? '△' : '▽';
});

watch(() => props.currentSort, (newSort) => {
  if (newSort !== props.column) {
    direction.value = props.defaultDirection;
  }
});

const handleSort = () => {
  if (isActive.value) {
    direction.value = direction.value === 'asc' ? 'desc' : 'asc';
  } else {
    direction.value = props.defaultDirection;
  }
  emit('sort', { column: props.column, direction: direction.value });
};
</script>

<style scoped>
@import '@/styles/shared-list.css';
</style>
